import request from '@/axios'
import qs from 'qs'

export interface UserType {
  id: number
  account: string
  name: string
  avatar: string
  roles: string[]
}

export interface UserLoginType {
  account: string
  password: string
  code?: string
  captchaKey?: string
}

export interface IResponse<T = any> {
  code: number
  data: T
  msg: string
}

export const getCaptchaApi = () => {
  return request.get({ url: '/captcha/base64' })
}

export const loginApi = (data: UserLoginType) => {
  return request.post({ 
    url: '/admin/login', 
    data: data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const loginOutApi = ()=> {
  return request.post({ url: '/admin/logout' })
}

export const getUserInfoApi = () => {
  return request.get({ url: '/admin/info' })
}
